import React, { useEffect, useState } from 'react';
import DateInput from '@/components/ui/date-input';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

function todayIso() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/**
 * Pflicht-Datum, bevor Lehrer-/Termin-/Bankänderungen den bisherigen Stand ersetzen.
 */
export default function EffectiveDateDialog({
  open,
  onOpenChange,
  title = 'Ab wann gilt die Änderung?',
  hint = 'Der bisherige Stand bleibt in der Historie erhalten.',
  onConfirm,
}) {
  const [value, setValue] = useState(todayIso);

  useEffect(() => {
    if (open) setValue(todayIso());
  }, [open]);

  const confirm = () => {
    if (!value) return;
    onConfirm(value);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="effective-date-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{hint}</DialogDescription>
        </DialogHeader>
        <label className="block text-xs font-medium text-slate-600">
          Gültig ab
          <DateInput
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="mt-1 h-9 text-sm"
            data-testid="effective-date-input"
          />
        </label>
        <DialogFooter className="gap-2">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Abbrechen
          </Button>
          <Button
            type="button"
            data-testid="effective-date-confirm"
            disabled={!value}
            onClick={confirm}
          >
            Übernehmen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
